<template>
  <div class="token">
    <dna-wrapper>
      <dna-search-bar></dna-search-bar>
      <dna-token-tracker></dna-token-tracker>
      <dna-token-table></dna-token-table>
    </dna-wrapper>
  </div>
</template>

<script>
import dnaSearchBar from '@/components/SearchBar/SearchBar.vue'
import dnaTokenTracker from '@/components/TokenTracker/TokenTracker.vue'
import dnaTokenTable from '@/components/TokenTable/TokenTable.vue'
export default {
  components: {
    dnaTokenTracker,
    dnaSearchBar,
    dnaTokenTable
  }
}
</script>

<style lang="less" scoped>
@import url('./Token.less');
</style>